"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var validateUrlDecOctet = /(?:[0-9]|(?:[1-9][0-9])|(?:1[0-9]{2})|(?:2[0-4][0-9])|(?:25[0-5]))/i;
exports.default = validateUrlDecOctet;
module.exports = exports["default"];